module.exports = __webpack_public_path__ + "static/psycho-leaf-7dfbfdf3e92419d08b33906fb0d0b6db.jpeg";